import ConfirmDialog from "../../../components/customHelpers/ConfirmDialog";
import Controls from "../../../components/controls/Controls";
import Norecords from "../../../components/customHelpers/Norecords";
import Loading from "../../../components/customHelpers/Loading";

import Layout from "../../../components/layout/Layout";
import { TableBody, TableRow, TableCell, Typography,makeStyles } from "@material-ui/core";

import { Grid, Toolbar, InputAdornment } from "@material-ui/core";
import { useEffect, useState } from "react";

import { MdOutlineDelete } from "react-icons/md";
import { IoMdAdd } from "react-icons/io";
import { AiOutlineSearch } from "react-icons/ai";
import useTable from "../../../components/customHelpers/useTable";
import Notify from "../../../components/customHelpers/Notify";
import Notification from "../../../components/customHelpers/Notification";
import { FiEdit } from "react-icons/fi";
import { Image_API } from "../../../config";

import Admin from "../../../components/auth/Admin";
import Catagory from "../../../actions/Catagory";
import AddMaincatagory from "../../../components/forms/AddCatagory";
import Popup from "../../../components/customHelpers/Popup";
import produce from "immer";
import { Paper } from "@mui/material";
import { useHistory } from "react-router-dom";
import {FiEye } from "react-icons/fi";

const headCells = [
  { id: "name", label: "Name" },
  { id: "image", label: "Image" },
  { id: "description", label: "Description" },

  { id: "actions", label: "Actions", disableSorting: true },
];
const useStyles = makeStyles((theme) => ({
  image: {
    borderRadius: "55%",
    height: "45px",
    width: "45px",
  },
}));
const Category = () => {
  const history = useHistory();
  const classes = useStyles();
  const { NotifyMessage, notify, setNotify } = Notify();
  const { viewAllCatagories, deleteCatagory } =
    Catagory();
    const [recordForEdit, setRecordForEdit] = useState(null);
    const [openPopup, setOpenPopup] = useState(false);
    const [edite, setEdit] = useState(false);
    const[categories,setCategories]=useState([])
  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  const { loading, reload } = values;
  useEffect(() => {
    getAllCategories();
  }, [reload]);

  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const getAllCategories = () => {
    setValues({ ...values, loading: true });
    viewAllCatagories().then((data) => {
      
      if (data.err) {
        setValues({
          ...values,
          loading: false,
        });
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else if (data.categorys) {
        setValues({
          ...values,
          loading: false,
        });
        setCategories(data.categorys)
      }
    });
  };
  const onDelete = (Id) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    deleteCatagory(Id).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
      } else {
        NotifyMessage({
          message: data.message,
          type: "success",
        });
        setValues({ ...values, reload: !reload });
        setCategories(
          produce(categories, (draft) => {
            const index = categories.findIndex(
              (catagory) => catagory.id === Id,
            )
            if (index !== -1) draft.splice(index, 1)
          }),
        )
      
      }
    });
  };
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(
      categories,
      headCells,
      filterFn
    );

  const handleSearch = (e) => {
    e.target.value = e.target.value.trimLeft();
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        const columns = ["name", "description"];

        if (target.value == "") return items;
        else {
          return items.filter((x) => {
            return columns.some((column) => {
              return (
                x[column]
                  .toString()
                  .toLowerCase()
                  .indexOf(target.value.toLowerCase()) > -1
              );
            });
          });
        }
      },
    });
  };

  return (
    <Layout>
      <Admin>
        <div className="card">
          <Typography variant="h6" className="page-header">
            Catagories
          </Typography>
          <Toolbar>
            <Controls.Input
              label="Search Catagories"
              className="searchInput"
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AiOutlineSearch />
                  </InputAdornment>
                ),
              }}
              onChange={handleSearch}
            />

            <Controls.Button
              text="Add Catagory"

              variant="outlined"
              startIcon={<IoMdAdd />}
              className="newButton"
              onClick={() => {
                setOpenPopup(true);
               setRecordForEdit(null);
              }}
            />
    
          </Toolbar>

          <Grid container>
            <Grid item xs={12} className="card__body">
              {loading ? (
                <Loading />
              ) : (
                <Paper style={{ overflowX: "auto" }}>
                  <TblContainer>
                    <TblHead />
                    <TableBody>
                      {recordsAfterPagingAndSorting().length > 0 ? (
                        recordsAfterPagingAndSorting().map((item) => (
                          <TableRow key={item.Id}>
                            <TableCell>{item.name}</TableCell>
                            <TableCell>
                              <img
                                className={classes.image}
                                src={`${Image_API}/${item.image}`}
                                alt={item.image}
                              />
                            </TableCell>
                            <TableCell>{item.description}</TableCell>
                            <TableCell>
                              <Controls.ActionButton
                                color="secondary"
                                title="Delete"
                                onClick={() => {
                                  setConfirmDialog({
                                    isOpen: true,
                                    title: "Are you sure to delete this Category?",
                                    subTitle: "You can't undo this operation",
                                    onConfirm: () => {
                                      onDelete(item.id);
                                    },
                                  });
                                }}
                              >
                                <MdOutlineDelete fontSize="medium" />
                              </Controls.ActionButton>
                              <Controls.ActionButton
                                color="primary"
                                title="Update"
                                onClick={() => {
                                  setOpenPopup(true);
                                 setRecordForEdit(item);
                                 setEdit(true)
                                }}
                              >
                                <FiEdit fontSize="medium" />
                              </Controls.ActionButton>
                              <Controls.ActionButton
                                color="primary"
                                title="View Detail"
                                onClick={() => {
                                  history.push(`/categories/${item.name}`);
                                }}
                              >
                                <FiEye fontSize="medium" />
                              </Controls.ActionButton>
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <Norecords col={6} />
                      )}
                    </TableBody>
                  </TblContainer>
                  <TblPagination />
                </Paper>
              )}
            </Grid>
          </Grid>

          <ConfirmDialog
            confirmDialog={confirmDialog}
            setConfirmDialog={setConfirmDialog}
          />
          <Notification notify={notify} setNotify={setNotify} />
        </div>
        <Popup
          title="Catagory Form"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        >
          <AddMaincatagory
            NotifyMessage={NotifyMessage}
            setOpenPopup={setOpenPopup}
            recordForEdit={recordForEdit}
            setCategories={setCategories}
            edite={edite}
          />
        </Popup>
      </Admin>
    </Layout>
  );
};

export default Category;
